<!-- 停售列表 -->
<template>
    <div class='page_content'>
        <toolStopRegistAction ref="toolStopRegistAction"></toolStopRegistAction>
        <substopselling ref="substopselling"></substopselling>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform"
                    :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-input v-if="formOneValue.entityField == 'bgmId'" clearable
                            @focus="$refs['showSelectData'].openBox('businessGoodsList', 'bgmId', 'bgmId')"
                            v-model="getRequestData.bgmName" :maxlength="$store.state.inputLength">
                        </el-input>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
                :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column type="selection" width="40">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                    v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                    :prop="tableValye.entityField" :label="tableValye.showField" v-if="tableValye.isShow == 1">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                        </span>
                        <div style="color:#409EFF;border-radius: 4px;" v-else-if="tableValye.entityField == 'ssmState'"
                            type="primary">
                            <span style="background-color:#d9ecff;">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</span>
                        </div>
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel"
                :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import toolStopRegistAction from '@/components/toolStopRegistAction.vue'
import substopselling from "@/components/substopselling.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { SearchScheme ,toolStopRegistAction,substopselling},
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                total: 0, // 总条数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: {},
            zt: [{ "key": 0, "value": "已停售" }, { "key": 1, "value": "合格,已解售" }, { "key": 2, "value": "不合格,转入不合格" }],
            DialogVisible: false,
            seId: "",
            seTitle: "",
            seWidth: "",
            parentSearchData: {},
            sField: "",
            selectVal: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        handleSelectionChange(val) {
            console.log(val)
            this.selectVal = val
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch({ sId, index, type, sField }) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        //表格数据写入excel
        export2Excel() {
            // tabindex
            var nameList = []; //表格头 显示的所有字段
            var fieldList = []; //所有字段 显示的所有字段
            var timeList = []; //date类型的字段 导出之前进行格式转换
            // 循环当前tab表格信息
            this.pageShowData['jurTableVo'].jurconfigtable.forEach((item) => {
                // 显示的字段
                if (item.isShow == 1) {
                    nameList.push(item.showField);
                    fieldList.push(item.entityField);
                }
                // 如果为date类型push
                if (item.fieldType == "date") {
                    timeList.push(item.entityField);
                }
            });
            var newList = JSON.parse(JSON.stringify(this.returnData.list))
            // 循环数据列表和时间字段数组 进行转换
            newList.forEach((item) => {
                timeList.forEach((timeitem) => {
                    item[timeitem] = this.$common.getLocalTime(item[timeitem]);
                });
                this.zt.forEach(keys => {
                    if (keys.key == item.ssmState) {
                        item.ssmState = keys.value
                    }
                })
            });
            this.$nextTick(() => {
                // 导出业务逻辑 引用封装好的js方法
                require.ensure([], () => {
                    const { export_json_to_excel } = require("@/assets/excel/Export2Excel");
                    //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
                    const tHeader = nameList; // 导出的excel表头名信息
                    const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
                    const list = newList; // 查询的数据list
                    // 进行数据json map 格式转换
                    const data = this.formatJson(filterVal, list);
                    // 调用方法传参      表头名信息 数据  导出的表格名称
                    export_json_to_excel(tHeader, data, this.$route.meta.title);
                });
            })

        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        
        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.bgmId = dataInfo.bgmId;
                        this.getRequestData.bgmName = dataInfo.bgmName;
                    }

                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        getPageInfo() {
            var ss = parent.getMenuInfo(this.$route.path);
            this.getDataTest(ss.jurId);
        },

        // 获取数据列表
        async getDataTest(ids) {
            let responseData = await this.$http.getJur({ ids: [ids] });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.getButtonList()
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
                this.formDataList = this.pageShowData.jurFormVoList
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.$refs["toolStopRegistAction"].openBox(0, this.formDataList, "");
                    break;
                case 1:
                    if (this.selectVal.length != 1) {
                        this.$message({
                            message: "请先选中一条数据操作",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.selectVal[0];

                    this.$refs["toolStopRegistAction"].openBox(
                        1,
                        this.formDataList,
                        dataInfo
                    );
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 6:
                    this.stopsReleaseStop()
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            if (this.selectVal.length != 1) {
                this.$message({
                    message: "请先选中一条数据操作",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.selectVal[0];
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(dataInfo.stId, sessionStorage.getItem('printSource').replace(/\"/g, ""), sessionStorage.getItem('printJurId'))
            } else {
                return
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.stopsqueryToolStop(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 解除停售数据
        stopsReleaseStop() {
            if (this.selectVal.length == 0) {
                this.$message({
                    message: "请先选择要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将解除停售, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: this.selectVal.map(item => item.stId)
                    };
                    let responseData = await this.$http.stopsliftStop(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "解除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                });
        },
        // 删除数据
        delDataAction() {
            if (this.selectVal.length == 0) {
                this.$message({
                    message: "请先选择要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: this.selectVal.map(item => item.stId),
                    };
                    let responseData = await this.$http.stopsdeleteToolStop(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();

        //获取字典
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>